// extracted by mini-css-extract-plugin
export var productImage = "_z6-0";